<template>
    <div class="block block-rounded block-fx-shadow block-mode-loading-refresh">
      <form @submit.stop.prevent="updateUserPermission">
        <div class="block-header block-header-default border-b mb-3">
            <h3 class="block-title">
              {{ $t('permissions.index') }}
            </h3>
            <div class="block-options">
                <button type="submit" class="btn btn-primary">
                  <i class="fa fa-save" v-if="!isProcessing"></i> <i class="fa fa-spinner fa-pulse" v-if="isProcessing"></i> {{ $t('buttons.save') }}
                </button>
            </div>
        </div>
        <div class="block-content">
          <div class="row">
            <div
              v-for="(permission, index) in adminPermissions"
              :class="{ 'col-md-12': adminPermissions.length <= 12, 'col-md-6': adminPermissions.length <= 24, 'col-md-4': adminPermissions.length >= 24,}"
              :key="index"
            >
              <div class="custom-control custom-checkbox mb-3" >
                <input type="checkbox" v-model="adminUser.selectedPermissions" class="custom-control-input" :id="`permission-${permission.id}`" :value="permission.id">
                <label class="custom-control-label" :for="`permission-${permission.id}`" :aria-describedby="`permisHelp-${permission.id}`" >{{permission.display_name}}</label>
                <small :id="`permisHelp-${permission.id}`" class="form-text text-muted">{{permission.name}}</small>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      errors: {},
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminUser',
      'adminPermissions',
    ]),
  },
  mounted() {
    this.GET_ADMIN_PERMISSIONS();
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_PERMISSIONS',
      'UPDATE_ADMIN_USER_PERMISSION',
      'GET_ADMIN_USER',
    ]),
    updateUserPermission() {
      this.isProcessing = true;
      this.UPDATE_ADMIN_USER_PERMISSION(this.adminUser)
        .then(() => {
          this.GET_ADMIN_USER(this.$route.params.id);
          this.editUser = false;
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
